module.exports = __webpack_public_path__ + "img/password_flatline.9534128e.svg";